import React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { withTranslation } from 'react-i18next';
import './ModuleSummaryRow.css';

function ModuleSummaryRow({ module, percentAnswered, t }) {
  return (
    <TableRow key={module}>
      <TableCell align='center'>
        {`${t('tabBar.module', { section: module })} / ${t(`summary.module-${module}`)}`}
      </TableCell>
      <TableCell
        align='center'
        className={classNames(percentAnswered === 100 && 'allModuleQuestionsAnswered', percentAnswered === 0 && 'noModuleQuestionsAnswered')}
      >
        {percentAnswered}
        %
      </TableCell>
    </TableRow>
  );
}

ModuleSummaryRow.propTypes = {
  t: PropTypes.func.isRequired,
  module: PropTypes.string,
  percentAnswered: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}
export default withTranslation('translations')(ModuleSummaryRow);
